import {DatePicker, Form} from "antd";

import "./Filters.css"
import dayjs, {Dayjs} from "dayjs";

export interface FilterDateProps{
    onChange?:(value:string)=>void
    className?:React.HTMLAttributes<HTMLDivElement>['className'];
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
    backendFormat?:string,
    displayFormat?:string,
    defaultValue?:Dayjs
}

export function FilterDate(props:FilterDateProps){
    const BACKEND_FORMAT = props.backendFormat ? props.backendFormat : 'YYYY-MM-DDTHH:mm:ss';
    const FRONTEND_FORMAT = props.displayFormat ? props.displayFormat : 'DD/MM/YYYY';
    const rules=[{
        required: props.required ?? false,
        message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio'
    }];

    function onChange(date: Dayjs | null){
        if(props?.onChange && date){
            const formattedValue = date.format(BACKEND_FORMAT);
            props?.onChange(formattedValue);
        }
    }

    const initialValue = props.defaultValue
        ? props.defaultValue.format(BACKEND_FORMAT)
        : undefined;

    const className = "filter " + (props?.className ?? "");

    return  <>
        <Form.Item
            name={props.dataKey}
            label={props.label}
            rules={rules}
            initialValue={initialValue}

            // Necessary for converting the value to the format of the backend
            getValueFromEvent={(value) => {
                return value ? value.format(BACKEND_FORMAT) : null;
            }}
            getValueProps={(value) => {
                return {
                    value: value ? dayjs(value, BACKEND_FORMAT) : null
                };
            }}
        >
            <DatePicker
                className={className}
                placeholder={props.placeholder ?? "Seleziona data"}
                onChange={onChange}
                // showTime={{ format: 'HH:mm:ss' }}

                allowClear={true}
                format={FRONTEND_FORMAT}
                defaultValue={props.defaultValue}


            />
        </Form.Item>
    </>
}